import React, { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useReactToPrint } from 'react-to-print';

import logo from '../assets/logo_patos.png';
import brasao from '../assets/brasao.png';


export const DialogPrintRomaneios = ({ visible, setVisible, romaneios, setRomaneios }) => {
    const cssText = `
    #print-content {
        font-family: 'Open Sans', sans-serif;
        width: 100%;
        text-align: center;
    }

    .contRomaneio {
        page-break-after: always;
    }
        .foot {
            page-break-after: always;
        }

        img {
            width: 50px;
            height: auto;
            display: block;
            border: block red;
        }

        .header-img {
            display: flex;
            justify-content: center;
        }

        .header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        h3 {
            margin-bottom: 0px;
            min-width: 100%;
            margin: 0 100px 0 100px;
            text-align: left;

        }

        h4 {
            margin-bottom: 0px;
            min-width: 100%;
            margin: 0 100px 0 100px;
            text-align: center;
            font-size: 11px;
        }

        h2 {
            margin-bottom: 0px;
            min-width: 100%;
            margin: 0 100px 0 100px;

        }

        h2 span {
            font-size: 11px;
        }

        th span {
            font-size: 11px;
            font-weight: normal;
        }

        thead {
            font-size: 10px;
            font-weight: normal;
        }

        tbody {
            font-size: 10px;
            font-weight: normal;
        }

        span {
            font-size: 8px;
        }

        #rodape {
            border-top: 1px solid #333;
            bottom: 0;
            left: 0;
            height: 40px;
            position: fixed;
            width: 100%;
        }

        #rodape2 {
            margin-top: 30px;
            border-top: 1px solid #333;
            bottom: 0;
            left: 0;
            height: 40px;
            width: 100%;
        }

        .content-row {
            page-break-inside: avoid;
          }

        .break-row {
            page-break-before: always;
        }


    `
    let counter = 0;
    const listaItens = (itens) => itens.map((item) => {
        let rowClass = "content-row";
        while (counter === 10) {
          rowClass = "break-row";
          counter = 0;
        }
        counter++;
        
        return (
            
            <tr key={counter} className={rowClass} style={{ pageBreakInside: "avoid" }}>
                <td width="230px" align='center'><span>{item.quantidade === 0 ? "" : item.quantidade}</span></td>
                <td width="230px" align='center'><span>{item.produtoEmbalagem}</span></td>
                <td width="230px" align='center'><span>{item.produtoNome}</span></td>
                <td width="230px" align='center'><span>{new Date(item.boletimItensInicioColheita).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</span></td>
                <td width="230px" align='center'><span>{new Date(item.boletimItensFimColheita).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</span></td>
                <td width="230px" align='center'><span>{item.boletimItensId == null ? "" : item.boletimItensBoletimPropriedadeNome + " - " + item.boletimItensBoletimPropriedadeMunicipioNome}</span></td>
            </tr>
        )
    })

    const listaPedras = (pedras) => {

        var tempPedras = ''

        for (let i = 0; i < pedras.length; i++) {
            if (i === 0) {
                tempPedras = pedras[i].pedrasNumero;
            } else {
                tempPedras = tempPedras + "," + pedras[i].pedrasNumero;
            }
        }

        return (
            <>  {tempPedras}  </>
        )
    }

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef, pageStyle: cssText });

    const header = (
        <div>
            <Button label="Imprimir" className="p-button-secondary" icon="pi pi-print" onClick={reactToPrintFn} />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header={header}
            className='p-scrollpanel-bar-y'
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', heigth: '5vw' }}
        >

            <div id="print-content" ref={contentRef}>

                {romaneios.length > 0 ?                

                    romaneios.map(item => (
                        <div className='contRomaneio'>
                            <table>
                                <tr>
                                    <th>
                                        <div className="p-d-flex p-jc-right header-img">
                                            <img style={{width:60, height:'auto'}}
                                                id="img"
                                                className='img'
                                                alt="brasao"
                                                src={brasao}
                                            />
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-d-flex p-jc-center header-img " >
                                            <h4> <span> MUNICÍPIO DE PATOS DE MINAS / SEC. MUNICIPAL DE AGRIC. PEC. E ABASTECIMENTO </span>  <br />
                                                CEASA REGIONAL  <br />
                                                CONTROLE ENTRADA DE MERCADORIA </h4>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-d-flex p-jc-left header-img">
                                            <img style={{width:60, height:'auto'}}
                                                id="img"
                                                alt="Logo"
                                                className='img'
                                                src={logo}
                                            />
                                        </div>
                                    </th>

                                </tr>

                            </table>

                            <hr />

                            <div className="p-d-flex p-ai-center p-flex-column header">

                                <table width="100%" border="0" style={{ 'border-collapse': 'collapse' }} cellpadding="5px" cellspacing="0">
                                    <thead>
                                        <th width="100px" >
                                            <span  >
                                                CPF
                                            </span>

                                        </th>
                                        <th width="100px" >
                                            <span>
                                                Produtor
                                            </span>

                                        </th>
                                        <th width="100px" >
                                            <span>
                                                Numero
                                            </span>

                                        </th>

                                        <th width="100px" >
                                            <span>
                                                Dívida
                                            </span>

                                        </th>

                                        <th width="100px" >
                                            <span>
                                                Pedras
                                            </span>

                                        </th>



                                    </thead>

                                    <tbody>

                                        <th width="100px" >

                                            {item.pessoa.cpfcnpj}

                                        </th>
                                        <th width="100px" >


                                            {item.pessoa.nome}

                                        </th>
                                        <th width="100px" >

                                            {item.id}

                                        </th>

                                        <th width="100px" >

                                            {item.divida}

                                        </th>

                                        <th width="100px" >

                                            {listaPedras(item.pedras)}

                                        </th>

                                    </tbody>

                                </table>

                            </div>

                            <hr />

                            <div className="p-d-flex p-ai-center p-flex-column header">
                                <table width="100%" border="0" style={{ 'border-collapse': 'collapse' }} cellpadding="3px" cellspacing="0">
                                    <thead>
                                        {/* <th width="100px" >
                                            <span>
                                                Nome da Propriedade
                                            </span>

                                        </th>
                                        <th width="100px" >
                                            <span>
                                                Município
                                            </span>

                                        </th> */}

                                        <th width="100px" >
                                            <span>
                                                Data impressão
                                            </span>

                                        </th>

                                        <th width="100px" >
                                            <span>
                                                Data Comércio
                                            </span>

                                        </th>

                                    </thead>

                                    <tbody>

                                        {/* <th width="100px" >

                                            {item.boletim.propriedade.nome}


                                        </th>
                                        <th width="100px" >

                                            {item.boletim.propriedade.municipio.nome}

                                        </th> */}


                                        <th width="100px" >


                                            {new Date().toLocaleDateString('pt-BR', { timeZone: 'UTC' })}



                                        </th>

                                        <th width="100px" style={{'fontSize': '22px'}}>

                                            {new Date(item.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}


                                        </th>



                                    </tbody>

                                </table>



                            </div>



                            <table width="100%" border="1" style={{ 'border-collapse': 'collapse', 'pageBreakInside': 'avoid'  }} cellpadding="5px" cellspacing="0">

                                <thead>
                                    <tr>

                                        <th width="100px" ><span><i>Qtde</i></span></th>
                                        <th width="100px" ><span><i>Unidade</i></span></th>
                                        <th width="100px" ><span><i>Produto</i></span></th>
                                        <th width="100px" ><span><i>Inicio</i></span></th>
                                        <th width="100px" ><span><i>Fim</i></span></th>
                                        <th width="100px" ><span><i>Propriedade - Municipio</i></span></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {listaItens(item.itens)}
                                    <p style={{ 'display': 'none'}}>{counter = 0}</p>
                                </tbody>

                            </table>



                            <footer id="rodape">
                            <table width="100%" border="0" style={{ 'border-collapse': 'collapse' }} cellpadding="5px" cellspacing="0">
                            <thead>
                                    <tr>

                                        <th width="80px" ><span><i>Assinatura do Produtor</i></span></th>
                                        <th width="100px" > - </th>
                                        <th width="80px" ><span><i>Data e Hora de chegada ao CEASA</i></span></th>
                                    </tr>
                                </thead>

                            </table>
                            </footer>

                        </div>
                    ))
                    :

                    null
                }
            </div>

        </Dialog>
    );
}
